import React from "react"
import Slider from "react-slick"
import arrowLeft from "../images/home/carrousel-arrow-left.svg"
import arrowRight from "../images/home/carrousel-arrow-right.svg"
import { Link } from "gatsby"

// Voice image
import seeker1 from "../images/voice/seeker1.webp"
import seeker2 from "../images/voice/seeker2.webp"
import seeker4 from "../images/voice/seeker4.webp"
import seeker5 from "../images/voice/seeker5.webp"
// Arrow right
import arrowRightLink from "../images/home/arrow-right.svg"

const JobSeekersCarousel = () => {
  // Arrows style

  function SampleNextArrow(props) {
    const { className, onClick } = props
    return (
      <div
        className={className}
        onClick={onClick}
        role="button"
        tabIndex="0"
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            onClick()
          }
        }}
      >
        <img src={arrowLeft} alt="carrousel-arrow-left" />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props
    return (
      <div
        className={className}
        onClick={onClick}
        role="button"
        tabIndex="0"
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            onClick()
          }
        }}
      >
        <img src={arrowRight} alt="carrousel-arrow-right" />
      </div>
    )
  }

  // Config Settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <div className="col-container">
      <div className="review-container desktop">
        <Slider {...settings}>
          <Link to="/jobseekers-voice/#seeker1">
            <div className="flex-center-card">
              <div key={"jCard1"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="cyan">求職者様</h3>
                    <img src={seeker1} alt="seeker1" width="96" height="96" />
                    <p>
                      30代女性 <br />
                      通訳翻訳
                    </p>
                  </div>
                  <div className="text">
                    <p>
                      正直、こんなに早く決まると思っていなかったので、Oさんのサポートに感謝しております。初回の面談時からとても丁寧なご対応をありがとうございました。今後、同じようにメキシコ転職を考え...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/jobseekers-voice/#seeker2">
            <div className="flex-center-card">
              <div key={"jCard2"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="cyan">求職者様</h3>
                    <img src={seeker2} alt="seeker2" width="96" height="96" />
                    <p>
                      20代男性 <br /> 営業
                    </p>
                  </div>
                  <div className="text">
                    <p>
                      スペイン語も英語も日常会話レベル以下だったこともあり、なかなか求人もなかった状況でしたが、約3か月にわたり転職活動のサポートをしていただき、誠にありがとうございました。最初は不安でしたが......
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/jobseekers-voice/#seeker5">
            <div className="flex-center-card">
              <div key={"jCard3"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="cyan">求職者様</h3>
                    <img src={seeker5} alt="seeker5" width="96" height="96" />
                    <p>
                      30代女性 <br /> 事務総務
                    </p>
                  </div>
                  <div className="text">
                    <p>
                      担当のOさんには、大変丁寧な面談から、先方様との面接の調整、進捗メールなど、とてもきめ細やかにサポートいただきましたこと、心より御礼申し上げます。約1ヶ月と短い期間ではございましたが、すでにメキシコで働かれている先輩とし…......
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/jobseekers-voice/#seeker4">
            <div className="flex-center-card">
              <div key={"jCard4"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="cyan">求職者様</h3>
                    <img src={seeker4} alt="seeker4" width="96" height="96" />
                    <p>
                      20代男性 <br /> 営業兼通訳
                    </p>
                  </div>
                  <div className="text">
                    <p>
                      就職支援をして頂いてから約4年が経過いたしましたが、お陰様で今日まで勤務を継続しています。Mさんには初回面談時から私の希望条件と市場価値、また強みだけではなく弱い部分までも真摯に向き合って頂い…......
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </Slider>
        <div class="link-cta">
          <a href="/jobseekers-voice" className="cyan">
            <img src={arrowRightLink} alt="arrow-right" />
            <span>全ての求職者様の声を見る</span>
          </a>
        </div>
      </div>
      <div className="review-container mobile">
        <div className="flex-center-card">
          <div key={"jCard1"} className="card">
            <div className="card-content">
              <div className="img-text">
                <h3 className="cyan">求職者様</h3>
                <img src={seeker1} alt="seeker1" width="96" height="96" />
                <p>
                  30代女性 <br /> 通訳翻訳
                </p>
              </div>
              <div className="text">
                <p>
                  正直、こんなに早く決まると思っていなかったので、Oさんのサポートに感謝しております。初回の面談時からとても丁寧なご対応をありがとうございました。今後、同じようにメキシコ転職を考え...
                </p>
                <div class="link-cta">
                  <a href="/jobseekers-voice" className="cyan">
                    <img src={arrowRightLink} alt="arrow-right" />
                    <span>全ての求職者様の声を見る</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JobSeekersCarousel
